import { render, staticRenderFns } from "./Bout.vue?vue&type=template&id=376fb7d6&"
import script from "./Bout.vue?vue&type=script&lang=js&"
export * from "./Bout.vue?vue&type=script&lang=js&"
import style0 from "./Bout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports